import useOrderAddressRepository from "../../../../repository/emergency/useOrderAddressRepository";
import {useEffect, useRef} from "react";
import isNull from "../../../../mixin/isNull";
import Box from "@mui/material/Box";
import {Alert, Button, Link} from "@mui/material";
import {CopyAll, GpsFixed} from "@mui/icons-material";
import useAlert from "../../../../use/useAlert";
import useClipboard from "../../../../use/useClipboard";
import useClientRepository from "../../../../repository/emergency/useClientRepository";
import Typography from "@mui/material/Typography";
import useOrderRepository from "../../../../repository/emergency/useOrderRepository";

export default function ({orderId}) {
    const alert = useAlert();
    const clipboard = useClipboard();
    const clientRepository = useClientRepository();
    const orderAddressRepository = useOrderAddressRepository();
    const orderRepository = useOrderRepository();
    /** @type OrderAddress */
    const orderAddress = orderAddressRepository.findOneByOrderId(orderId).select();
    /** @type Client */
    const client = clientRepository.findOneByOrderId(orderId).select();
    /** @type Order */
    const order = orderRepository.findOneById(orderId).select();
    const googleMapLink = useRef();

    useEffect(() => {
        orderAddressRepository.findOneByOrderId(orderId).exec(false);
        clientRepository.findOneByOrderId(orderId).exec();
        orderRepository.findOneById(orderId).exec();
    }, []);

    const handleOpenMap = () => {
        googleMapLink.current.click();
    }

    const handleCopyCoordinate = () => {
        clipboard(`${orderAddress.getLat()},${orderAddress.getLng()}`);

        alert.success("Copié !");
    }

    const handleCopyAddress = () => {
        clipboard(`${orderAddress.getLine1()} ${isNull(orderAddress.getLine2()) ? "" : orderAddress.getLine2()} ${isNull(orderAddress.getLine3()) ? "" : orderAddress.getLine3()}, ${orderAddress.getPostcode()} ${orderAddress.getCity()}`);

        alert.success("Copié !");
    }

    if (isNull(orderAddress) || isNull(client)) return null;

    return (
        <>
            <Typography textAlign="center" fontWeight={"bold"} variant="h5">
                {client.getName()}
            </Typography>
            <Typography mt={5} textAlign="center">
                {orderAddress.getLine1()} {orderAddress.getLine2()} {orderAddress.getLine3()}, <br/>{orderAddress.getPostcode()} {orderAddress.getCity()}
            </Typography>
            <Box mt={10} display="flex" justifyContent="center">
                <Button
                    startIcon={<GpsFixed/>}
                    variant={"contained"}
                    sx={{width: "80%"}}
                    onClick={handleOpenMap}
                    data-test="button-open-map"
                    fullWidth={true}
                >
                    Ouvrir mon GPS
                </Button>
            </Box>
            <Box mt={5} display="flex" justifyContent="center">
                <Button
                    startIcon={<CopyAll/>}
                    variant={"contained"}
                    sx={{width: "80%"}}
                    onClick={handleCopyCoordinate}
                    fullWidth={true}
                >
                    Copier les coordonnées GPS
                </Button>
            </Box>
            <Box mt={5} display="flex" justifyContent="center">
                <Button
                    startIcon={<CopyAll/>}
                    variant={"contained"}
                    sx={{width: "80%"}}
                    onClick={handleCopyAddress}
                    fullWidth={true}
                >
                    Copier l'adresse
                </Button>
            </Box>
            <Link
                ref={googleMapLink}
                href={`https://www.google.com/maps/dir/?api=1&origin=Current%20Location&destination=${orderAddress.getLat()},${orderAddress.getLng()}`}
                target={"_blank"}
                color={"inherit"}
                underline={"none"}
            />

            {
                !isNull(order)
                    ? (
                        <Box mt={3}>
                            <Alert severity={"info"}>
                                Descriptif : {order.getOrderComment()}
                            </Alert>
                        </Box>
                    )
                    : null
            }
        </>
    )
}